module.exports = __webpack_public_path__ + "static/media/Warlock.471f596b.png";